import { Grid, Typography } from '@material-ui/core';
import GridItem from 'components/Grid/GridItem.jsx';
import React from 'react';

const grandSeperator = val => {
	if(!val) {
		return "0"
	}
	
	val = val
		.toString()
		.replace(/,/g, '')
		.replace(/ /g, '');
	let parsed = parseInt(val);

	if (!isNaN(parsed)) {
		return parsed.toLocaleString().replace(/,/g, ' ');
	} else {
		return val;
	}
};

const customRow = (firstCol, secondCol, thirdCol) => {
	return (
	  <React.Fragment>
		<Grid item xs={12} sm={12} md={12}>
		  <Grid container>
			<GridItem xs={3} sm={3} md={3}>
			  {firstCol}
			</GridItem>
			<GridItem xs={2} sm={2} md={2}>
			  {secondCol}
			</GridItem>
			<GridItem xs={2} sm={2} md={2}>
			  {thirdCol}
			</GridItem>
			<GridItem xs={5} sm={5} md={5}>
			  
			</GridItem>
		  </Grid>
		</Grid>
	  </React.Fragment>
	);
  };

const Residue = props => {
	const residue = props.state.result.residue;

	return (
		<React.Fragment>
			<Grid
				direction="column"
				style={{ marginTop: '20px', marginBottom: '20px' }}
			>
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						<strong>Total assets and deemed assets: </strong>
					</Typography>,
					null,
					<Typography style={{ paddingTop: '5px' }}>
						<strong>
							R {grandSeperator(residue.totalAssets)}
						</strong>
					</Typography>
				)}

				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						<strong>Minus: </strong>
					</Typography>,
					null,
					<Typography style={{ paddingTop: '5px' }}>
						<strong>R {grandSeperator(residue.minus)}</strong>
					</Typography>
				)}

				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Policies not payable to estate
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(residue.policies)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Bequests to other
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(residue.bequestsToOther)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Cash bequests to other
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(residue.cashBequestsToOther)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Bequests to spouse
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(residue.bequestsToSpouse)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Cash bequests to spouse
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(residue.cashBequestsToSpouse)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Liabilities
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(residue.liabilities)}
					</Typography>,
					null
				)}

				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Costs
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(residue.costs)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Accrual claim by spouse
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(residue.accrualClaimBySpouse)}
					</Typography>,
					null
				)}

				<div style={{ marginTop: '20px' }} />
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Residue before Estate Duty
					</Typography>,
					null,
					<Typography style={{ paddingTop: '5px' }}>
						<strong>R {grandSeperator(residue.residueBeforeEstateDuty)}</strong>
					</Typography>
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Minus Estate duty by estate
					</Typography>,
					null,
					<Typography style={{ paddingTop: '5px' }}>
						<strong>R {grandSeperator(residue.minusEstateDuty)}</strong>
					</Typography>
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						<strong>Residue</strong>
					</Typography>,
					null,
					<Typography style={{ paddingTop: '5px' }}>
						<strong>R {grandSeperator(residue.residue)}</strong>
					</Typography>
				)}
			</Grid>
		</React.Fragment>
	);
};

export default Residue;



// WEBPACK FOOTER //
// ./src/views/Fna/ResultsPage/results/Residue.jsx